import React, { useRef, useEffect } from 'react';
import classes from './Checkbox.module.css';

/**
 * @typedef Props
 * @prop {boolean} checked
 * @prop {React.ChangeEventHandler<HTMLInputElement>} onChange
 * @prop {boolean=} disabled
 * @prop {boolean=} indeterminate
 */

/**
 * @type {React.FC<Props & React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>>}
 */
const Checkbox = ({
  checked,
  children,
  onChange,
  disabled,
  indeterminate,
  ...props
}) => {
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (!checkboxRef.current) return;
    checkboxRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <label className={classes.label} {...props}>
      <input
        ref={checkboxRef}
        type='checkbox'
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <div className={classes.content}>{children}</div>
    </label>
  );
};

export default Checkbox;
